module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--4--create-21fdd7cf.png";